<template>
    <Tab>
        <Panel :rounded-corners="false">
            <h2 slot="head" class="visible-xs-block">
                <span>
                    <svgicon icon="figures-magnifier" width="26" height="23" :original="true" />
                </span>
                <strong>We're Hiring</strong>
            </h2>

            <div slot="content">
                <div class="">
                    <div v-if="!isCareerPlug" class="job-text">
                        <p>
                            {{ jobText }}
                            <a :href="office.job_url" target="_blank">Click here to see our current job openings</a>
                        </p>
                    </div>
                    <div v-else>
                        <h3>Here's our current openings</h3>
                        <ul class="jobs">
                            <li v-for="(job, index) in office.jobs" :key="index" class="job-listing">
                                <h4>
                                    <a :href="job.url">{{ job.title }}</a>
                                </h4>
                                <div>{{ job.location }} - {{ job.type }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Panel>
    </Tab>
</template>
<script>
import Tab from '@/components/SectionTabs/Tab.vue';
import Panel from '@/components/Shared/Panel.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'Hiring',
    components: { Tab, Panel },
    computed: {
        ...mapGetters(['office']),
        isCareerPlug() {
            return (this.office.job_url || '').includes('careerplug.com');
        },
        jobText() {
            return (this.office.job_text || '').replace(
                'Click here to see our current job openings',
                ''
            );
        },
    },
};
</script>
<style lang="scss">
.jobs {
    list-style: none;
}
.job-listing {
    margin-bottom: 20px;
    div {
        color: $green;
    }
    h4 {
        margin-bottom: 3px;
        a {
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
.job-text {
    font-size: 16px;
    line-height: 1.39;
    margin-bottom: 20px;
}
.job-text p {
    margin-bottom: 0;
}
</style>
